module.exports = __webpack_public_path__ + "img/Komisaris-Independent-Ricky-Avicenna-new.5964df4b.jpg";